import type * as React from 'react';
import { get } from '@Domain/Api';
import facilityWorkflowRunsFetched, {
	type FacilityWorkflowRunsFetchedAction,
	type FacilityWorkflowRunsFetchedPayload,
} from '@Application/WorkflowRuns/FacilityWorkflowRuns/Actions/facilityWorkflowRunsFetched';
import facilityWorkflowRunsFetchFailed, {
	type FacilityWorkflowRunsFetchFailedAction,
} from '@Application/WorkflowRuns/FacilityWorkflowRuns/Actions/facilityWorkflowRunsFetchFailed';
import type FetchFacilityWorkflowRuns from '@Application/WorkflowRuns/FacilityWorkflowRuns/Queries/FetchFacilityWorkflowRuns';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = FacilityWorkflowRunsFetchedAction | FacilityWorkflowRunsFetchFailedAction;

export default (query: FetchFacilityWorkflowRuns) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const baseUrl = `${parameters.api.host}/api/facilities/${query.facilityId}/workflow-runs`;
			const queryString = query.toQueryString();
			const url = queryString.length > 0 ? `${baseUrl}?${queryString}` : baseUrl;

			const payload = await get<FacilityWorkflowRunsFetchedPayload>(url);

			const action = facilityWorkflowRunsFetched(payload, query.facilityId, query.queryKey);
			dispatch(action);
			return action;
		} catch (error) {
			const action = facilityWorkflowRunsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
